<div class='login' id='home-login-registration'>
    <div class='inner-wrapper'>
        <div class="logo">
            <img alt="Loop Plus" src="./assets/logos/loop-plus-text-white.svg"/>
        </div>

        <!--        <div class='headline' i18n='@@loginheadline'><span>loop+</span> Zugang!</div>-->

        <div class='form'>
            <div class='inner'>
                <div class='title'><span class="color-loop">Loop Plus</span>&nbsp;&nbsp;<span i18n='@@logintitle'>Account Login</span></div>

                <form #loginForm='ngForm' (ngSubmit)='login()'>

                    <div class='input'>
                        <input
                            [(ngModel)]='formData.username'
                            autocomplete='false'
                            i18n-placeholder='@@username'
                            id='username'
                            minlength='3'
                            name='username'
                            pInputText
                            placeholder='Benutzername'
                            required
                            type='text'
                        />
                    </div>

                    <div class='input'>
                        <input
                            [(ngModel)]='formData.password'
                            autocomplete='false'
                            i18n-placeholder='@@password'
                            id='password'
                            minlength='3'
                            name='password'
                            pInputText
                            placeholder='Passwort'
                            required
                            type='password'
                        />
                    </div>

                    <button
                        i18n-label='@@login'
                        label='Login'
                        pButton
                        pRipple
                        type='submit'
                    ></button>

                    <div class='lost-pw'>
                        <a (click)='showPasswortReset(true)' i18n='@@lostpassword'>Passwort vergessen?</a>
                    </div>
                </form>
            </div>
        </div>

        <div class='copy'>
            <ng-container i18n='@@noaccountmessage'>Du hast noch keinen Zugang?</ng-container>
            <br/>
            <a [routerLink]="['/register/step1']" i18n='@@registerhere'>Hier registrieren</a>
        </div>

    </div><!-- /.inner -->

    <app-meta-nav></app-meta-nav>

    <div id='background-images'>
        <swiper-container #backgroundSwiper [config]='swiperBackgroundSlider' appSwiper init='false'>
            <swiper-slide>
                <div class='image'><img alt="Loop Plus background 1" src='./assets/home/background-1.jpg'/></div>
            </swiper-slide>
            <swiper-slide>
                <div class='image'><img alt="Loop Plus background 2" src='./assets/home/background-2.jpg'/></div>
            </swiper-slide>
            <swiper-slide>
                <div class='image'><img alt="Loop Plus background 3" src='./assets/home/background-3.jpg'/></div>
            </swiper-slide>
        </swiper-container>
    </div>

    <div [ngClass]="{'show' : passwortReset === true}" id='forgot-pw'>
        <div class='inner'>
            <div class='form'>
                <div class='title' i18n='@@password.forgotten'>Passwort vergessen?</div>
                <form #resetForm='ngForm' (ngSubmit)='resetPasswordData()' [class.ng-submitted]='resetSubmitted'>
                    <input
                        #mail='ngModel'
                        [(ngModel)]='email'
                        [ngClass]="{ 'p-invalid': mail.invalid }"
                        id='float-input-position'
                        minlength='3'
                        name='email'
                        pInputText
                        pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$'
                        placeholder='E-Mail'
                        required
                        type='email'
                    />
                    <button
                        i18n-label='@@button.password.reset'
                        iconPos='left'
                        label='Passwort zurücksetzen'
                        pButton
                        pRipple
                        type='submit'
                    ></button>
                </form>


                <button (click)='showPasswortReset(false)' class='close'></button>
            </div>
        </div>
    </div>

</div><!--/#home-page-wrapper -->
